// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AUTOGENERIERT aus shared/base.css — NICHT direkt editieren!
   Quelle ändern und ./scripts/sync-shared.sh ausführen. */
.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 2rem 1rem;
}

.button-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
}

.section-title {
  font-family: 'Staatliches', sans-serif;
  font-size: 4rem !important;
  font-weight: normal;
  text-transform: uppercase;
  margin-bottom: 1rem;
  text-align: center;
}

`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA;0DAC0D;AAC1D;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* AUTOGENERIERT aus shared/base.css — NICHT direkt editieren!\n   Quelle ändern und ./scripts/sync-shared.sh ausführen. */\n.container {\n  max-width: 900px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n}\n\n.button-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 1rem;\n}\n\n.section-title {\n  font-family: 'Staatliches', sans-serif;\n  font-size: 4rem !important;\n  font-weight: normal;\n  text-transform: uppercase;\n  margin-bottom: 1rem;\n  text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
